<div id="{{ controlName }}-input-container" [formGroup]="parentForm">
  <button
    type="submit"
    [disabled]="disabled"
    [ngClass]="{ disabled: disabled }">
    {{ value }}
  </button>
</div>
